export interface Message {
  id: string
  role: 'user' | 'assistant'
  content: string
  timestamp: Date
  isStreaming?: boolean
}

export interface Conversation {
  id: string
  title: string
  messages: Message[]
  model: string
  createdAt: Date
  updatedAt: Date
}

export interface Model {
  id: string
  name: string
  description: string
  badge?: string
}

export const MODELS: Model[] = [
  { id: 'QWen3', name: 'QWen3', description: '轻量快速，日常对话', badge: 'Pro' },
  { id: 'ep-20260408145008-wq8hw', name: '豆包 Seed 2.0 Lite', description: '豆包轻量版，快速响应', badge: 'New' }
]

export const SUGGESTIONS = [
  { icon: '✍️', text: '帮我写一首关于秋天的诗' },
  { icon: '🧑‍💻', text: '用 Vue 3 实现一个 Todo List' },
  { icon: '🍜', text: '给我推荐几道简单的家常菜' },
  { icon: '🌌', text: '解释一下量子纠缠是什么' },
  { icon: '😂', text: '给我讲一个程序员的笑话' },
  { icon: '💪', text: '制定一个一周健身计划' },
]
export interface UploadedFile {
  id: string
  file: File
  url?: string
  uploading?: boolean
  progress?: number
}
